import React, { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { Icon, Loading } from "source/shared/components"
import { useSession } from "source/shared/hooks/useSession"

const DirectoryInvitationDecline = () => {
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [error, setError] = useState("")
  const [warning, setWarning] = useState("")
  const [loginUrl, setLoginUrl] = useState(null)

  const {
    meta: { authenticated },
  } = useSession()

  useEffect(() => {
    sessionApiClient
      .post("/people/v2/decline_directory_invitation", {
        data: {
          attributes: {
            _e: searchParams.get("_e"),
          },
        },
      })
      .then((response) => {
        setLoading(false)
        setHasError(false)
        setLoginUrl(response.meta.login_url)
      })
      .catch(({ errors }) => {
        setLoading(false)
        setHasError(true)
        const errorDetail = errors?.[0]?.detail
        if (errorDetail.match(/warning:/))
          setWarning(errorDetail.replace(/warning:/, ""))
        else setError(errorDetail.replace(/error:/, ""))
      })
  }, [searchParams])

  const renderErrorMessage = () => {
    return error ? (
      <div className="alert error-alert d-f fd-c ai-c g-1">
        <Icon
          className="fs-0 c-ruby"
          symbol="general#exclamation-triangle"
          aria-hidden
        />
        <h2>Uh oh! Something is wrong.</h2>
        <p className="mb-0">{error}</p>
      </div>
    ) : warning ? (
      <div className="alert warning-alert d-f fd-c ai-c g-1">
        <Icon
          className="fs-0 c-citrine"
          symbol="general#exclamation-triangle"
          aria-hidden
        />
        <h2>Uh oh! Something is wrong.</h2>
        <p className="mb-0">{warning}</p>
      </div>
    ) : (
      <div className="alert error-alert d-f fd-c ai-c g-1">
        <Icon
          className="fs-0 c-ruby"
          symbol="general#exclamation-triangle"
          aria-hidden
        />
        <h2>Uh oh! That link wasn&#39;t valid.</h2>
        <p className="mb-0">Try copying the link directly from your email.</p>
      </div>
    )
  }

  return loading ? (
    <Loading />
  ) : hasError ? (
    renderErrorMessage()
  ) : (
    <div className="d-f fd-c">
      <div className="alert success-alert d-f jc-c ai-c g-1 fd-c">
        <Icon
          className="fs-3 c-emerald"
          symbol="general#check-circle"
          aria-hidden
        />
        <h2>Thanks for letting us know!</h2>
        <p className="mb-0">
          Your information won&apos;t be shared in the directory.
        </p>
      </div>
      <div
        style={{
          marginTop: "16px",
          borderTop: "1px, solid var(--color-tint5)",
        }}
      >
        {!authenticated && (
          <span>
            If you change your mind and would like to join the directory,{" "}
            <a href={`${loginUrl}`}>please log in to Church Center</a>. Once
            logged in, you can view the directory, customize which information
            is shared, and share information about others in your household.
          </span>
        )}
      </div>
    </div>
  )
}

export default DirectoryInvitationDecline
